import { useTranslation } from 'react-i18next';
import { Breakpoint, Col, Grid, GridWidth, Typography } from 'app/component-library-wave';
import { Navigation } from 'app/features/navigation/navigation';
import { navigationService } from 'app/service/navigation/navigation-service';
import { ResubscribeInformation } from '../resubscribe-information/resubscribe-information';

import styles from '../common.module.scss';
import { InactiveCustomerLocationPage } from 'app/pages/page-wrapper';

export const InactiveAccount: InactiveCustomerLocationPage = (props) => {
  const { t } = useTranslation();

  const allLinkSections = [
    {
      pages: [
        navigationService.PAGES.invoice,
        navigationService.PAGES.invoiceLyse,
        navigationService.PAGES.invoiceLegacy,
        navigationService.PAGES.users,
        navigationService.PAGES.email,
      ],
    },
  ];
  const personalizedLinkSesction = navigationService.getPersonalizedLinkSections(allLinkSections, props.userContext);

  return (
    <>
      <ResubscribeInformation />
      <Grid width={GridWidth.NARROW}>
        <Col sm={2} md={6} lg={12}>
          <div className={styles.container}>
            <Typography
              component="h1"
              variant="headline5"
              maxBreakpoint={Breakpoint.TABLET}
              className={styles.headline}
            >
              {t(navigationService.PAGES.account.i18n)}
            </Typography>

            {personalizedLinkSesction.map((section, idx) => (
              <div key={`listkey-${idx}`}>
                <Navigation section={section} />
              </div>
            ))}
          </div>
        </Col>
      </Grid>
    </>
  );
};
